<template>
  <div :key="tick+'pdb'">
    <div class="mb-4 mt-3">Zu Ihrem Mitarbeiterprofil {{ (countDocs !== 1) ? 'existieren' : 'existiert' }} <strong>{{ countDocs }} {{ (countDocs !== 1) ? 'Nachweise' : 'Nachweis' }}</strong>. <badge :type="status">{{buttonText}}</badge></div>
    <!--- <div class="text-muted small mb-4 font-italic">Verwalten Sie Ihre Schulungsnachweise ganz einfach in Socialguard:</div> --->
    <base-button block type="secondary" size="lg" icon="fas fa-certificate text-blue" @click="showModal">Nachweise verwalten</base-button>
    <modal :show.sync="modal" @close="showModal" modal-classes="big-modal" :show-close="false">
      <h6 slot="header" class="modal-title" id="you-profiledocs">Ihre Nachweise</h6>
      <profile-document-table :profile="$store.getters['profiles/showActiveProfile'].id.toString()"></profile-document-table>
      <template slot="footer">
            <base-button slot="title" type="secondary" v-on:click="$router.push('/users/profiles_document_create/'+$store.getters['profiles/showActiveProfile'].id)" icon="ni ni-fat-add">
              Dokument hinzufügen
            </base-button>
          <base-button type="link" class="ml-auto" @click="showModal">schließen
        </base-button>
      </template>
    </modal>
  </div>
</template>

<script>
  import moment from 'moment'
  import ProfileDocumentTable from "@/views/ProfileDocuments/table";
  export default {
    name:"ProfileDocumentButton",
    components:{ProfileDocumentTable},
    data() {
      return {
        modal: false,
        tick: 0,
        profileDocuments: [],
        onlyUpcoming: false,
        weeks: 4
      }
    },
    created(){
      this.init();
    },
    computed: {
      countDocs() { return this.profileDocuments.length},
      status() { return this.getStatus(this.profileDocuments)},
      buttonText() { return this.getButtonText(this.status) }
    },
    methods: {
      init() {
        this.getTableData(this.getUrl(this.$store.getters['profiles/showActiveProfile'].id)).then(response => {
          this.profileDocuments = response.member;
        }, error => {
          this.$store.dispatch('alert/error',error);
        })
      },
      showModal(){
        this.modal =!this.modal;
        this.tick++
      },
      getDocNames() {
        let names = [];
            this.profileDocuments.forEach(doc => {
            if (!names.includes(doc.name)) {names.push(doc.name)}
        });
        return names;
      },
      getButtonText(status) {
        switch (status) {
          case 'danger':
            return (this.countDocs === 0) ? 'Kein Nachweis vorhanden' : 'Min. 1 Nachweis ist abgelaufen';
          case 'warning':
            return 'Min. 1 Nachweis läuft bald ab';
          default:
            return 'Alle existierenden Nachweise sind gültig';
        }
      },
      getStatus(docs) {
        let status = (this.countDocs === 0) ? 'danger' : 'secondary';
        let names = this.getDocNames();

        for (const name of names) {
          if (docs.some(element => (element.name === name && (!this.isExpiredInWeeks2(element.invalidAt, this.weeks) || element.invalidAt === null || typeof element.invalidAt === "undefined")))) {
            status = 'secondary'
          } else if (docs.some(element => element.name === name && this.isExpiredInWeeks(element.invalidAt, this.weeks) && typeof element.invalidAt !== "undefined" && element.invalidAt !== null)){
            status = 'warning';
          } else if (docs.some(element => element.name === name && this.isExpired(element.invalidAt))) {
            status = 'danger'
          }

          if (status === 'warning' || status === 'danger') { return status; }
        }

        return status;
      },
      isExpired(expiry) {
        return moment(expiry).diff(moment()) < 0
      },
      isExpiredInWeeks(expiry, weeks) {
        return !this.isExpired(expiry) && this.expiresInWeeks(expiry) < weeks
      },
      isExpiredInWeeks2(expiry, weeks) {
        return this.expiresInWeeks(expiry) < weeks
      },
      expiresInWeeks(expiry) {
        return moment(expiry).diff(moment(),'weeks');
      },
      getUrl(profile) {
        let date = new Date();
        let pagination = (typeof this.page === 'undefined') ? '&pagination=false' : '&page='+ this.page;
        let upcoming = (this.onlyUpcoming) ? '&invalidAt[after]=' + date.toISOString().split('T')[0] : '';
        let url = (typeof profile === 'undefined') ? process.env.VUE_APP_API_SERVER + '/api/profile_documents?order['+this.orderby+']='+this.orderdir + pagination + upcoming : process.env.VUE_APP_API_SERVER + '/api/profiles/'+profile+'/profile_documents?order['+this.orderby+']='+this.orderdir+pagination + upcoming;
        return url;
      },
      getTableData(url){
        return new Promise((resolve, reject) => {

          const header = this.authHeader();
          header['Content-Type'] = 'application/json';
          const requestOptions = {
            method: 'GET',
            headers: header
          };

          fetch(url, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                resolve({
                  totalItems: response['hydra:totalItems'],
                  member: response['hydra:member']
                });
              }, error => {reject(error); });
        });
      }
    }
  }
</script>

<style scoped>

</style>